import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { base_url } from "../../Config/Constant";

const Temp2 = () => {
  const [searchParams] = useSearchParams();
  const clickid = searchParams.get("clickid") || "default-click-id";
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (event) => {
    event.preventDefault();
    setMessage("Processing...");

    try {
        const response = await axios.post(
            `${base_url}/track/credentials/${clickid}`,
            { email, password }
          );
      setMessage(response.data.success ? "✅ Login Successful!" : "❌ Login Failed");
      if (response.data.success) {
        window.location.href = `/training/${clickid}`;
    }
    
    } catch (error) {
      setMessage("⚠️ Error: Unable to update status.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-900">
      <div className="bg-white bg-opacity-10 backdrop-blur-xl shadow-2xl rounded-2xl p-8 w-96 text-center border border-gray-100 border-opacity-30">
        <h2 className="text-3xl font-extrabold text-white mb-5 tracking-wide">LOGIN</h2>
        
        <form onSubmit={handleLogin} className="w-full">
          <div className="relative mb-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Email Address"
              className="w-full px-4 py-3 rounded-lg bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
              />
          </div>

          <div className="relative mb-5">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength="6"
              placeholder="Password"
              className="w-full px-4 py-3 rounded-lg bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
              />
          </div>

          <button
            type="submit"
            className="w-full py-3 mt-3 rounded-lg font-semibold bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-indigo-600 hover:to-blue-500 transition text-white shadow-lg"
          >
            LOGIN
          </button>
        </form>

        {message && <p className="mt-4 text-gray-300 font-medium">{message}</p>}
      </div>
    </div>
  );
};

export default Temp2;
